import { navigate } from '@reach/router';

const { PUBLIC_URL } = process.env;

export type GoBackOptionsProps = {
    path?: string;
    isReplace?: boolean;
};

export const navigateTo = (destination: string): Promise<void> =>
    navigate(`${PUBLIC_URL || ''}${destination}`);

export const goBack = (options?: GoBackOptionsProps): Promise<void> =>
    options?.path
        ? navigate(`${PUBLIC_URL || ''}${options?.path}`, {
            replace: options?.isReplace || false,
        })
        : navigate(-1);
